import React, { createContext, useContext, useState, useEffect } from 'react';
import { isAuthenticated, getAccessToken } from '../utils/jwt';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isAuthenticatedState, setIsAuthenticatedState] = useState(false);

  useEffect(() => {
    // Check authentication status on mount
    setIsAuthenticatedState(isAuthenticated());
  }, []);

  const value = {
    isAuthenticated: isAuthenticatedState,
    setIsAuthenticated: setIsAuthenticatedState,
    getToken: getAccessToken,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
